import React from 'react'
import * as serviceWorker from './serviceWorker'
import App from './App'
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

